import { downloadFile } from "./downloadFile";

export const handleOnDownloadClick = async (url: string): Promise<void> => {
    const fileName = url.split("/").pop();

    if (!fileName) {
        return;
    }

    await downloadFile(url, fileName);
};
